import { ReactNode, useEffect, useRef } from 'react';

/**
 * Pins top strips (env banner, urgent-actions banner) at the very top and
 * publishes their combined height as `--nxsys-topbar-h` so the sticky app
 * header can offset below them instead of overlapping (NX-5160).
 */
const TopBarStack = ({ children }: { children: ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const root = document.documentElement;
    const apply = () =>
      root.style.setProperty('--nxsys-topbar-h', `${el.offsetHeight}px`);
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => {
      ro.disconnect();
      root.style.setProperty('--nxsys-topbar-h', '0px');
    };
  }, []);

  return (
    <div ref={ref} style={{ position: 'sticky', top: 0, zIndex: 1100 }}>
      {children}
    </div>
  );
};

export default TopBarStack;
